import { useQuery } from "@tanstack/react-query";

import { createDescriptionQuery } from "./options";

type UseTechnologiesDescriptionQueryOptions = {
    enabled?: boolean;
};

export default function useTechnologiesDescriptionQuery({
    enabled = true,
}: UseTechnologiesDescriptionQueryOptions = {}) {
    return useQuery(createDescriptionQuery({ enabled }));
}
